module.exports = __webpack_public_path__ + "static/media/screen_rotation_black_24dp.b90ddb67.svg";